export interface SystemNoticeMeta {
  color: string;
  icon: string;
  label: string;
}

const META: Record<string, SystemNoticeMeta> = {
  info: { color: '#0288d1', icon: 'info', label: 'Informatie' },
  warning: { color: '#ed6c02', icon: 'warning', label: 'Waarschuwing' },
  error: { color: '#d32f2f', icon: 'error', label: 'Storing' },
  success: { color: '#2e7d32', icon: 'new_releases', label: 'Wat is er nieuw?' },
};

// Normaliseert de vrije type-waarde uit de API naar een van de vier bekende typen.
const ALIASES: Record<string, string> = {
  info: 'info', information: 'info', informatie: 'info',
  warning: 'warning', warn: 'warning', waarschuwing: 'warning',
  error: 'error', danger: 'error', critical: 'error', storing: 'error',
  success: 'success', new: 'success', news: 'success', whatsnew: 'success', nieuw: 'success',
};

export const getSystemNoticeMeta = (type?: string | null): SystemNoticeMeta => {
  const key = (type ?? '').toLowerCase().trim();
  const normalized = ALIASES[key] ?? 'info';
  return META[normalized];
};
